import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { GlobalUtilityService } from './global-utility.service'; // Import the global utility service

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private globalUtilityService: GlobalUtilityService) {}

  handleError(error: any) {
    let errorMessage = 'An unexpected error occurred!';

    // Extract error message from the response
    if (error.error && error.error.message) {
      errorMessage = error.error.message; // Backend error message
    } else if (error.message) {
      errorMessage = error.message; // Frontend error message
    }

    // Show error toast
    this.globalUtilityService.showToast('Error', errorMessage);

    // Optionally, log the error or send it to an analytics service
    console.error('Error:', errorMessage);

    return throwError(() => new Error(errorMessage)); // Throw error with message
  }
}
